import React from 'react';

import { MenuEntry } from '@europrocurement/flexy-components';

import { KeycloakRoute, REALM_ADMIN, REALM_COMPTA } from '@europrocurement/l2d-keycloak';
import {
    doneInvoiceIcon,
    invoiceIcon,
    myInvoiceIcon,
    pausedInvoiceIcon,
    pausedStatementIcon,
    rejectCodesList,
    rejectCodesOnInvoicesIcon,
    statsOnInvoicesIcon,
    todoInvoiceIcon,
} from '@europrocurement/l2d-icons';
import MediaObjectImportView from './views/imports/MediaObjectImportView';
import RegisterSimpleInvoiceView from './views/forms/simple/RegisterSimpleInvoiceView';
import UpdateSimpleInvoiceView from './views/forms/simple/UpdateSimpleInvoiceView';

import AchatsRoot from './AchatsRoot';
import StatsView from './views/stats/StatsView';
import RegisteredInvoicesView from './views/lists/RegisteredInvoicesView';
import RegisterMultiInvoiceView from './views/forms/multi/RegisterMultiInvoiceView';
import { EnteteSaisieMultiple } from './components/forms/multi/steps/EnteteSaisieMultiple';
import { DossierSaisieMultiple } from './components/forms/multi/steps/DossierSaisieMultiple';
import { RecapSaisieMultiple } from './components/forms/multi/steps/RecapSaisieMultiple';
import { NextDossierSaisieMultiple } from './components/forms/multi/steps/NextDossierSaisieMultiple';
import UnclosedRegisteredInvoicesView from './views/lists/UnclosedRegisteredInvoicesView';
import { NextEditDossierSaisieMultiple } from './components/forms/multi/steps/NextEditDossierSaisieMultiple';
import {
    achatsBasePath,
    consulterMultiFacturePath,
    downloadPath,
    invoiceStatementPath,
    listePath,
    modifierFacturePath,
    nextDossierMultiFacturePath,
    nextEditDossierMultiFacturePath,
    nextEditFproDossierMultiFacturePath,
    pausePath,
    recapFproMultiFacturePath,
    recapMultiFacturePath,
    summaryStatementPath,
    registerStatementPath,
    saisirDossierMultiFacturePath,
    saisirEditDossierMultiFacturePath,
    saisirEditFproDossierMultiFacturePath,
    saisirEnteteMultiFacturePath,
    saisirEnteteMultiFactureStatementPath,
    saisirFacturePath,
    saisirMultiFacturePath,
    statsPath,
    traitePath,
    uploadPath,
    readUnclosedStatementPath,
    internMediaObjectsPath,
    updateStatementPath,
    rejectCodesPath,
} from './constants/paths';
import achatsViewPathResolver from './achatsViewPathResolver';
import UnregisteredInvoicesView from './views/lists/UnregisteredInvoicesViews/UnregisteredInvoicesView';
import { RecapFproSaisieMultiple } from './components/forms/multi/steps/RecapFproSaisieMultiple';
import UnclosedInvoiceStatementsView from './views/lists/UnclosedInvoiceStatementsView';
import ReadStatementView from './views/forms/statement/ReadStatementView';
import SummaryStatementView from './views/forms/statement/SummaryStatementView';
import InternUnregisteredInvoicesView from './views/lists/InternUnregisteredInvoicesView';
import UpdateMultiInvoiceView from './views/forms/multi/UpdateMultiInvoiceView';
import UpdateMultiPublicationForm from './components/forms/multi/UpdateMultiPublicationForm';
import UpdateMultiFormalityForm from './components/forms/multi/UpdateMultiFormalityForm';
import RejectCodesList from './views/lists/RejectCodesList';
import RejectCodeDetail from './views/detail/RejectCodeDetail';
import RejectCodeRoot from './subroots/RejectCodeRoot';

const VALID_ROLES = [REALM_ADMIN, REALM_COMPTA];

export const AchatsRouter = {
    path: achatsBasePath,
    element: <AchatsRoot />,
    children: [
        {
            path: listePath,
            children: [
                // La liste des factures a traiter
                {
                    path: '',
                    index: true,
                    element: (
                        <KeycloakRoute roles={VALID_ROLES}>
                            <UnregisteredInvoicesView />
                        </KeycloakRoute>
                    ),
                },
                // La liste des factures a traiter en interne
                {
                    path: internMediaObjectsPath,
                    index: true,
                    element: (
                        <KeycloakRoute roles={VALID_ROLES}>
                            <InternUnregisteredInvoicesView />
                        </KeycloakRoute>
                    ),
                },
                // Vue de la liste des relevés de facture non clôturé
                {
                    path: invoiceStatementPath,
                    index: true,
                    element: (
                        <KeycloakRoute roles={VALID_ROLES}>
                            <UnclosedInvoiceStatementsView />
                        </KeycloakRoute>
                    ),
                },
                // Télécharge le fichier PDF
                {
                    path: downloadPath,
                    index: true,
                    element: (
                        <>
                            <br />
                            **Téléchargement du PDF... ** <br />
                            <br /> la page doit se fermée directement et laisser le navigateur web
                            gérer le téléchargement.
                        </>
                    ),
                },
                // Saisie d'une nouvelle facture liée à un PDF
                {
                    path: saisirFacturePath,
                    index: true,
                    element: <RegisterSimpleInvoiceView />,
                },
                // Saisie d'une nouvelle facture multi-annonces liée à un PDF
                {
                    path: saisirMultiFacturePath,
                    abstract: true,
                    // index: true,
                    element: <RegisterMultiInvoiceView />,
                    children: [
                        {
                            path: saisirEnteteMultiFactureStatementPath,
                            index: true,
                            element: <EnteteSaisieMultiple />,
                        },
                        {
                            path: saisirEnteteMultiFacturePath,
                            index: true,
                            element: <EnteteSaisieMultiple />,
                        },
                        {
                            path: saisirDossierMultiFacturePath,
                            element: <DossierSaisieMultiple />,
                        },
                        {
                            path: nextDossierMultiFacturePath,
                            element: <NextDossierSaisieMultiple />,
                        },
                        {
                            path: saisirEditDossierMultiFacturePath,
                            element: <UpdateMultiPublicationForm />,
                        },
                        {
                            path: saisirEditFproDossierMultiFacturePath,
                            element: <UpdateMultiFormalityForm />,
                        },
                        {
                            path: nextEditDossierMultiFacturePath,
                            element: <NextEditDossierSaisieMultiple />,
                        },
                        {
                            path: nextEditFproDossierMultiFacturePath,
                            element: <NextEditDossierSaisieMultiple isFormalite />,
                        },
                        {
                            path: recapMultiFacturePath,
                            element: <RecapSaisieMultiple />,
                        },
                        {
                            path: recapFproMultiFacturePath,
                            element: <RecapFproSaisieMultiple />,
                        },
                    ],
                },
                // Modification
                {
                    path: modifierFacturePath,
                    index: true,
                    element: (
                        <KeycloakRoute roles={VALID_ROLES}>
                            <UpdateSimpleInvoiceView />
                        </KeycloakRoute>
                    ),
                },
                {
                    path: consulterMultiFacturePath,
                    index: true,
                    element: (
                        <KeycloakRoute roles={VALID_ROLES}>
                            <UpdateMultiInvoiceView />
                        </KeycloakRoute>
                    ),
                },
                // La liste des factures traitées
                {
                    path: traitePath,
                    index: true,
                    element: (
                        <KeycloakRoute roles={VALID_ROLES}>
                            <RegisteredInvoicesView />
                        </KeycloakRoute>
                    ),
                },
                // La liste des factures en pause
                {
                    path: pausePath,
                    index: true,
                    element: <UnclosedRegisteredInvoicesView />,
                },
                {
                    element: <RejectCodeRoot />,
                    children: [
                        {
                            path: rejectCodesPath,
                            children: [
                                {
                                    path: '',
                                    index: true,
                                    element: (
                                        <KeycloakRoute roles={VALID_ROLES}>
                                            <RejectCodesList />
                                        </KeycloakRoute>
                                    ),
                                },
                                {
                                    path: ':idRejectCode',
                                    element: (
                                        <KeycloakRoute roles={VALID_ROLES}>
                                            <RejectCodeDetail />
                                        </KeycloakRoute>
                                    ),
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        // Saisie d'une nouvelle facture liée à un PDF et un relevé
        {
            path: registerStatementPath,
            index: true,
            element: (
                <KeycloakRoute roles={VALID_ROLES}>
                    <RegisterSimpleInvoiceView />
                </KeycloakRoute>
            ),
        },
        // Édition d'une facture liée à un PDF et un relevé
        {
            path: updateStatementPath,
            index: true,
            element: (
                <KeycloakRoute roles={VALID_ROLES}>
                    <UpdateSimpleInvoiceView />
                </KeycloakRoute>
            ),
        },
        // Consultation d'un relevé de factures
        {
            path: readUnclosedStatementPath,
            index: true,
            element: (
                <KeycloakRoute roles={VALID_ROLES}>
                    <ReadStatementView />
                </KeycloakRoute>
            ),
        },
        // Recap des factures d'un relevé
        {
            path: summaryStatementPath,
            index: true,
            element: (
                <KeycloakRoute roles={VALID_ROLES}>
                    <SummaryStatementView />
                </KeycloakRoute>
            ),
        },
        {
            path: uploadPath,
            element: (
                <KeycloakRoute roles={VALID_ROLES}>
                    <MediaObjectImportView />
                </KeycloakRoute>
            ),
        },
        {
            path: statsPath,
            element: (
                <KeycloakRoute roles={VALID_ROLES}>
                    <StatsView />
                </KeycloakRoute>
            ),
        },
    ],
};

export const AchatsMenuEntries: MenuEntry[] = [
    {
        title: 'Portail Achats',
        role: VALID_ROLES,
        icon: 'file-invoice-dollar',
        children: [
            {
                title: 'Import',
                icon: 'file-import',
                href: achatsViewPathResolver('uploadMediaObject'),
                role: VALID_ROLES,
            },
            {
                title: 'Factures',
                icon: invoiceIcon,
                role: VALID_ROLES,
                children: [
                    {
                        title: 'À traiter',
                        icon: todoInvoiceIcon,
                        href: achatsViewPathResolver('listmediaobject'),
                        role: VALID_ROLES,
                    },
                    {
                        title: 'À traiter en interne',
                        icon: myInvoiceIcon,
                        href: achatsViewPathResolver('listmediaobjectinternally'),
                        role: VALID_ROLES,
                    },
                    {
                        title: 'Traitées',
                        icon: doneInvoiceIcon,
                        role: VALID_ROLES,
                        href: achatsViewPathResolver('listfacture'),
                    },
                    {
                        title: 'En pause',
                        icon: pausedInvoiceIcon,
                        href: achatsViewPathResolver('listfacturepause'),
                        role: VALID_ROLES,
                    },
                    {
                        title: 'Relevés non clôturés',
                        icon: pausedStatementIcon,
                        href: achatsViewPathResolver('listInvoiceStatement'),
                        role: VALID_ROLES,
                    },
                ],
            },
            {
                title: 'Codes Rejets',
                icon: rejectCodesOnInvoicesIcon,
                role: VALID_ROLES,
                children: [
                    {
                        title: 'Gestion des erreurs',
                        icon: statsOnInvoicesIcon,
                        href: achatsViewPathResolver('achatsstats'),
                        role: VALID_ROLES,
                    },
                    {
                        title: 'Configuration des codes rejets',
                        icon: rejectCodesList,
                        href: achatsViewPathResolver('listRejectCodes'),
                        role: VALID_ROLES,
                    },
                ],
            },
        ],
    },
];
